import React, { useState, useEffect } from 'react';
import './DateWidget.css';

function DateWidget() {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setDate(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const dayName = days[date.getDay()];
  const monthName = months[date.getMonth()];
  const day = date.getDate();

  return (
    <div className="date-widget">
      <div className="widget-label">DATE</div>
      <div className="date-content">
        <div className="date-day">{dayName}</div>
        <div className="date-month-day">{monthName} {day}</div>
      </div>
    </div>
  );
}

export default DateWidget;




